import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ecbef78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fixed inset-0 bg-black bg-opacity-50 overflow-hidden z-40 flex justify-center items-center",
  ref: "modal-backdrop"
}
const _hoisted_2 = { class: "blur-container flex items-start justify-center text-center backdrop-filter backdrop-blur-sm block overflow-hidden" }
const _hoisted_3 = {
  class: "main-container bg-white text-left block overflow-hidden relative w-9/12",
  role: "dialog",
  ref: "modal",
  "aria-modal": "true",
  "aria-labelledby": "modal-headline"
}
const _hoisted_4 = { class: "header text-center pt-8" }
const _hoisted_5 = { class: "title ubuntu text-primary font-bold text-xl" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-4 mx-6" }, null, -1))
const _hoisted_7 = { class: "content px-6 pt-6 text-center" }
const _hoisted_8 = { class: "open-sans px-8" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = {
  class: "block text-primary-700 font-bold mb-2 float-left ubuntu",
  for: "email"
}
const _hoisted_11 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_12 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_13 = { class: "buttons relative bottom-0 w-full sm:absolute sm:bottom-8" }
const _hoisted_14 = { class: "grid justify-center grid-cols-2 gap-6 mx-6 text-center font-bold" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  style: {"display":"inherit","margin-bottom":"2px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('password-recovery-modal.title')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('password-recovery-modal.description')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('password-recovery-modal.email.label')), 1),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["appearance-none rounded w-full py-4 px-3 text-black-700 mb-8 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline sm:mb-3", { border: _ctx.v$.email.$error }]),
              id: "email",
              type: "email",
              placeholder: "Enter your email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.email.$touch && _ctx.v$.email.$touch(...args)))
            }, null, 34), [
              [_vModelText, _ctx.email]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_11, _toDisplayString(_ctx.$t('password-recovery-modal.email.required')), 1))
                  : _createCommentVNode("", true),
                (error.$validator == 'email')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_12, _toDisplayString(_ctx.$t('password-recovery-modal.email.valid')), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "cancel-button cursor-pointer px-12 py-4 text-white bg-gray-400 rounded text-lg",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
            }, _toDisplayString(_ctx.$t('password-recovery-modal.button.cancel')), 1),
            _createElementVNode("button", {
              class: _normalizeClass(["bg-primary text-white font-bold py-4 px-4 rounded w-full ubuntu flex justify-center hover:bg-primary-600 focus:outline-none focus:shadow-outline", { disabled : _ctx.v$.$invalid }]),
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSend())),
              disabled: _ctx.v$.$invalid || _ctx.isLoading
            }, [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_19))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.$t('password-recovery-modal.button.send')), 1)
            ], 10, _hoisted_15)
          ])
        ])
      ], 512)
    ])
  ], 512))
}